// extracted by css-extract-rspack-plugin
export default {"graph":"graph___UOyHl","title":"title___3THjK","graphChart":"graphChart___jBokY","linkMenu":"linkMenu___KllGy","btn_contain":"btn_contain___+Ubq-"};